(function ($, w) {

    "use strict";

    w.Confused = w.Confused || {};

    /**
    * Confused.StaticLabelProvider returns labels from the lookup service
    * 
    * @constructor
    * @param {object} labels to provide
    **/
    w.Confused.StaticLabelProvider = function () {

        var domain = new w.Confused.DomainProvider().getDomain(w.location);

        this.labels = {

            "policyText": "We use cookies to give you the best experience on our site. If you continue browsing, we'll assume you're happy to receive all cookies from our site. ",
            "policyLinkText": "Read our cookie policy to learn more.",
            "policyLinkUrl": "http://" + domain + "/cookie-policy"
        };
    };

    /*
    * Gets a label. e.g.
    * labelProvider.getLabel(name)
    *
    * @param {string} key. The name of the label. Return and empty string if no match exists.
    **/
    w.Confused.StaticLabelProvider.prototype.getLabels = function () {

        var def = $.Deferred();

        def.resolve(this.labels);

        return def;
    };

}(window.jQuery, window));

